/**
 * Tekla-style PDP gallery: swipe carousel, progress bar, slide fraction, caption words.
 */
(function () {
  function debounce(fn, wait) {
    let t;
    return function (...args) {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  function getSlideIndex(slider, slides) {
    if (!slider || !slides.length) return 0;
    const scrollLeft = slider.scrollLeft;
    let closest = 0;
    let minDist = Infinity;
    slides.forEach((slide, index) => {
      const dist = Math.abs(slide.offsetLeft - scrollLeft);
      if (dist < minDist) {
        minDist = dist;
        closest = index;
      }
    });
    return closest;
  }

  function initGallery(mediaGallery) {
    if (mediaGallery.dataset.cuatroGalleryInit === 'true') return;
    mediaGallery.dataset.cuatroGalleryInit = 'true';

    const viewer = mediaGallery.querySelector('[id^="GalleryViewer-"]');
    const slider = viewer && viewer.querySelector('[id^="Slider-Gallery-"]');
    const slides = slider ? Array.from(slider.querySelectorAll('.product__media-item')) : [];
    const chrome = mediaGallery.querySelector('[data-cuatro-gallery-chrome]');
    if (!slider || !slides.length || !chrome) return;

    const progressFill = chrome.querySelector('[data-cuatro-gallery-progress]');
    const captionEl = chrome.querySelector('[data-cuatro-gallery-caption]');
    const currentEl = chrome.querySelector('[data-cuatro-gallery-current]');
    const totalEl = chrome.querySelector('[data-cuatro-gallery-total]');
    const prevBtn = chrome.querySelector('[data-cuatro-gallery-prev]');
    const nextBtn = chrome.querySelector('[data-cuatro-gallery-next]');

    const total = slides.length;
    if (totalEl) totalEl.textContent = String(total);

    function captionForSlide(slide) {
      const fromSlide = slide.getAttribute('data-slide-caption');
      if (fromSlide) return fromSlide;
      return mediaGallery.getAttribute('data-default-slide-caption') || '';
    }

    function updateUI(index) {
      const clamped = Math.max(0, Math.min(index, total - 1));
      if (currentEl) currentEl.textContent = String(clamped + 1);
      if (progressFill) {
        const pct = total <= 1 ? 100 : ((clamped + 1) / total) * 100;
        progressFill.style.width = pct + '%';
      }
      if (captionEl) {
        const nextCaption = captionForSlide(slides[clamped]);
        const instantCaption = document.documentElement.classList.contains('cuatro-product-is-swapping');
        if (captionEl.textContent !== nextCaption) {
          if (instantCaption) {
            captionEl.textContent = nextCaption;
            if (nextCaption) captionEl.classList.add('is-visible');
            else captionEl.classList.remove('is-visible');
          } else {
            captionEl.classList.remove('is-visible');
            window.requestAnimationFrame(() => {
              captionEl.textContent = nextCaption;
              if (nextCaption) captionEl.classList.add('is-visible');
            });
          }
        } else if (nextCaption) {
          captionEl.classList.add('is-visible');
        }
      }
      if (prevBtn) prevBtn.disabled = clamped <= 0;
      if (nextBtn) nextBtn.disabled = clamped >= total - 1;
    }

    function scrollToIndex(index) {
      const clamped = Math.max(0, Math.min(index, total - 1));
      const slide = slides[clamped];
      if (!slide) return;
      slider.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      updateUI(clamped);
    }

    slider.addEventListener(
      'scroll',
      debounce(() => {
        updateUI(getSlideIndex(slider, slides));
      }, 80)
    );

    viewer.addEventListener('slideChanged', (event) => {
      const el = event.detail && event.detail.currentElement;
      if (!el) return;
      const index = slides.indexOf(el);
      if (index >= 0) updateUI(index);
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        scrollToIndex(getSlideIndex(slider, slides) - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        scrollToIndex(getSlideIndex(slider, slides) + 1);
      });
    }

    let touchStartX = 0;
    slider.addEventListener(
      'touchstart',
      (e) => {
        touchStartX = e.changedTouches[0].screenX;
      },
      { passive: true }
    );
    slider.addEventListener(
      'touchend',
      (e) => {
        const dx = e.changedTouches[0].screenX - touchStartX;
        if (Math.abs(dx) < 40) return;
        const current = getSlideIndex(slider, slides);
        scrollToIndex(dx < 0 ? current + 1 : current - 1);
      },
      { passive: true }
    );

    slider.style.touchAction = 'pan-x';
    slider.setAttribute('tabindex', '0');

    slider.scrollLeft = 0;
    updateUI(0);
  }

  function addBusinessDays(fromDate, days) {
    const result = new Date(fromDate);
    let added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
      const day = result.getDay();
      if (day !== 0 && day !== 6) added += 1;
    }
    return result;
  }

  function formatTeklaRange(minDate, maxDate) {
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const minDay = minDate.getDate();
    const maxDay = maxDate.getDate();
    const minMonth = months[minDate.getMonth()];
    const maxMonth = months[maxDate.getMonth()];
    if (minMonth === maxMonth) {
      return minDay + ' ' + minMonth + ' \u2013 ' + maxDay + ' ' + maxMonth;
    }
    return minDay + ' ' + minMonth + ' \u2013 ' + maxDay + ' ' + maxMonth;
  }

  function initDeliveryRanges() {
    document.querySelectorAll('[data-cuatro-delivery-range]').forEach((el) => {
      const minDays = parseInt(el.getAttribute('data-min-days') || '3', 10);
      const maxDays = parseInt(el.getAttribute('data-max-days') || '5', 10);
      const start = new Date();
      const minDate = addBusinessDays(start, minDays);
      const maxDate = addBusinessDays(start, maxDays);
      el.textContent = formatTeklaRange(minDate, maxDate);
    });
  }

  function initDeliveryTabs() {
    document.querySelectorAll('.cuatro-estimated-delivery__tabs').forEach((tablist) => {
      const root = tablist.closest('.cuatro-estimated-delivery__panel');
      if (!root) return;
      tablist.querySelectorAll('[data-cuatro-delivery-tab]').forEach((tab) => {
        tab.addEventListener('click', () => {
          const key = tab.getAttribute('data-cuatro-delivery-tab');
          tablist.querySelectorAll('.cuatro-estimated-delivery__tab').forEach((t) => {
            t.classList.toggle('is-active', t === tab);
            t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
          });
          root.querySelectorAll('[data-cuatro-delivery-panel]').forEach((panel) => {
            const active = panel.getAttribute('data-cuatro-delivery-panel') === key;
            panel.classList.toggle('is-active', active);
            panel.hidden = !active;
          });
        });
      });
    });
  }

  function boot() {
    document.querySelectorAll('media-gallery.cuatro-pdp-gallery--tekla').forEach(initGallery);
    initDeliveryRanges();
    initDeliveryTabs();
  }

  window.cuatroRefreshPdpEnhancements = boot;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
